var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10156 9.19103H20.8199",
    stroke: "#27B7B2",
    strokeWidth: 1.97882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8706 13.5123H15.8808",
    stroke: "#27B7B2",
    strokeWidth: 1.97882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9614 13.5123H10.9717",
    stroke: "#27B7B2",
    strokeWidth: 1.97882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04246 13.5123H6.05271",
    stroke: "#27B7B2",
    strokeWidth: 1.97882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8706 17.8121H15.8808",
    stroke: "#27B7B2",
    strokeWidth: 1.97882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9614 17.8121H10.9717",
    stroke: "#27B7B2",
    strokeWidth: 1.97882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04246 17.8121H6.05271",
    stroke: "#27B7B2",
    strokeWidth: 1.97882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4304 1V4.64053",
    stroke: "#27B7B2",
    strokeWidth: 1.97882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49388 1V4.64053",
    stroke: "#27B7B2",
    strokeWidth: 1.97882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6453 2.74707H6.27803C3.02922 2.74707 1 4.55688 1 7.88357V17.895C1 21.274 3.02922 23.1257 6.27803 23.1257H15.635C18.8941 23.1257 20.913 21.3054 20.913 17.9787V7.88357C20.9233 4.55688 18.9043 2.74707 15.6453 2.74707Z",
    stroke: "#27B7B2",
    strokeWidth: 1.97882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar01);
export default __webpack_public_path__ + "static/media/calendar01.98c8249dcf5577217083e8953cba87b7.svg";
export { ForwardRef as ReactComponent };